import { Controller } from "@hotwired/stimulus"

// Filters Cup::FileLayouts::Editor::FieldPathOverrides::Component's rows
// between "only fields with an override configured" (the switch's default,
// checked, state) and "every known field" — purely client-side (no server
// round-trip), same philosophy as tabs_controller.js. A row's own path input
// value is the single source of truth for "configured": an empty box already
// means "no override" (FieldPathOverridesController#update deletes the row
// on a blank submit), so filtering never needs anything the DOM doesn't
// already have.
//
// The switch's checked state is remembered in sessionStorage so a full-card
// re-render (e.g. an optimistic-lock conflict) doesn't snap it back to the
// server-rendered default — mirrors tabs_controller.js's restoreKey.
export default class extends Controller {
  static targets = ["toggle", "group", "empty"]
  static values = { restoreKey: String }

  connect() {
    const stored = this.#storedChecked()
    if (stored !== null) this.toggleTarget.checked = stored
    this.apply()
    this.onEdited = () => this.apply()
    window.addEventListener("file-layout:edited", this.onEdited)
  }

  disconnect() {
    window.removeEventListener("file-layout:edited", this.onEdited)
  }

  apply() {
    const showAll = !this.toggleTarget.checked
    this.#storeChecked(this.toggleTarget.checked)

    let anyGroupVisible = false
    this.groupTargets.forEach((group) => {
      let groupVisible = false
      group.querySelectorAll("[data-test-id='field-path-override-row']").forEach((row) => {
        const input = row.querySelector("[data-test-id='field-path-override-path']")
        const visible = showAll || input.value.trim() !== ""
        row.classList.toggle("hidden", !visible)
        if (visible) groupVisible = true
      })
      group.classList.toggle("hidden", !groupVisible)
      if (groupVisible) anyGroupVisible = true
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", anyGroupVisible)
  }

  #storageKey() {
    return this.restoreKeyValue ? `field-path-overrides:${this.restoreKeyValue}` : null
  }

  #storedChecked() {
    const key = this.#storageKey()
    if (!key) return null
    const raw = window.sessionStorage.getItem(key)
    return raw === null ? null : raw === "true"
  }

  #storeChecked(value) {
    const key = this.#storageKey()
    if (key) window.sessionStorage.setItem(key, String(value))
  }
}
